<script setup lang="ts">
import { i18n } from '@/i18n';
import { computed } from 'vue';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    threshold: string | undefined;
    defaultValueString?: string;
  }>(),
  { defaultValueString: undefined }
);
const emits = defineEmits(['update:threshold']);

const computedThreshold = computed(() => props.threshold ?? '1.0');
</script>
<template>
  <div class="alert-input-consecutive">
    <div class="label">{{ t('shortage_forecast_current_high') }}</div>
    <div>
      <I18nT
        keypath="dashboard:アラート条件:内示に対して当月の出荷済み数量がn%を超える"
        tag="span"
        class="alert-input-consecutive__condition"
      >
        <template #n>
          <input
            :value="computedThreshold"
            type="number"
            min="0"
            max="999"
            class="alert-input-consecutive__input alert-input-consecutive__input--percentage"
            @input="emits('update:threshold', $event)"
            @keydown.e.prevent
          />
        </template>
      </I18nT>
    </div>
    <div v-if="defaultValueString" class="default-value">
      {{ defaultValueString }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.alert-input-consecutive {
  display: grid;
  grid-template-rows: max-content;
  gap: 8px;
  padding: 8px;
  border-radius: 4px;

  *:not(.material-icons) {
    font-family: Noto Sans JP;
  }

  .label {
    font-weight: 700;
  }

  &__input {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    line-height: 1;
    &--percentage {
      width: 80px;
    }
    &--quantity {
      width: 94px;
    }
  }
}
.default-value {
  font-size: 13px;
  color: $textSecondary;
}
</style>
